<template>
  <div class="dropdown-wrapper" ref="wrapper" >
    <slot name="trigger" :toggle="toggle" :open="isOpen"></slot>

    <portal to="dropdown-portal" v-if="isOpen">
        <div
          class="dropdown-content"
          :style="dropdownStyle"
          @click.stop
        >
          <slot name="content" :open="isOpen" :toggle="toggle" ></slot>
        </div>
    </portal>
  </div>
</template>

<script>

export default {
  name: 'ReusableDropdown',
  props:{
    options: Object
  },
  data() {
    return {
      isOpen: false,
      dropdownStyle: {
        position: 'absolute',
        top: '0px',
        left: '0px',
        width: 'auto',
        zIndex: 1000,
      },
    }
  },
  mounted() {
    window.addEventListener('scroll', this.updatePosition, true)
    window.addEventListener('resize', this.updatePosition)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updatePosition, true)
    window.removeEventListener('resize', this.updatePosition)
  },
  methods: {
    toggle() {
      if(this.isOpen) {
        this.$emit('close');
        setTimeout(() => {
          this.isOpen = !this.isOpen
        },600)
        document.removeEventListener('click', this.closeOnOutsideClick)
      }
      else{
        setTimeout(() => {
          this.$emit('open');
        },300)
        this.isOpen = !this.isOpen
        this.$nextTick(this.updatePosition)
        document.addEventListener('click', this.closeOnOutsideClick)
      }
     
    },
    closeOnOutsideClick(event) {
      let target = event.target;
      if(!this.$refs.wrapper) return
      if (this.$refs.wrapper && this.$refs.wrapper.contains(target)) return
      this.$emit('close');
      setTimeout(() => {
        this.isOpen = false
      },600)
      document.removeEventListener('click', this.closeOnOutsideClick) 
    },
    updatePosition() {
      if (!this.isOpen) return
      const trigger = this.$refs.wrapper
      if (!trigger) return
      const rect = trigger.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
      const viewportWidth = document.documentElement.clientWidth;

      let width = this.options && this.options.width
        ? this.options.width
        : `calc(${rect.width}px + 5rem)`;

      this.dropdownStyle = {
        position: 'absolute',
        top: `${rect.top + scrollTop}px`,
        right: `${viewportWidth - rect.right - scrollLeft}px`,
        width: width,
        minWidth: `${rect.width}px`,
        zIndex: 1000,
      };
    },
  },
}
</script>

<style>
.dropdown-content {
  /* box-shadow: 0 5px 10px rgba(0,0,0,0.1); */
  font-size: clamp(14px, 1.5vw, 16px);
  min-height: 32px;
}

/* transition example */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

